import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import { COLORS, FONT } from "../../constants";
import { LOGO_URL, STEPS } from "./constants";

const ApplicationSidebar = ({ currentStep, isMobile }) => {
  return (
    <Box
      sx={{
        width: isMobile ? "100%" : "40%",
        flexShrink: 0,
        p: isMobile ? 3 : 4,
        borderRight: isMobile ? "none" : "1px solid #efefef",
        borderBottom: isMobile ? "1px solid #efefef" : "none",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        component="img"
        src={LOGO_URL}
        alt="Argus"
        sx={{
          height: 120,
          width: "auto",
          objectFit: "contain",
          alignSelf: "flex-start",
          mb: 3,
        }}
      />

      <Typography
        sx={{
          fontWeight: 600,
          fontSize: isMobile ? FONT.size.md : FONT.size.lg,
          textTransform: "uppercase",
          color: COLORS.themeBlack,
          mb: 1,
          letterSpacing: 0.5,
        }}
      >
        Account Application
      </Typography>
      <Typography
        sx={{
          fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
          color: COLORS.lightText,
          mb: 4,
          lineHeight: 1.7,
        }}
      >
        Apply for a COD Account with Argus and unlock a robust product range and
        trade pricing.
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {STEPS.map((step, index) => {
          const isActive = step.number === currentStep;
          const isCompleted = step.number < currentStep;
          return (
            <Box key={step.number} sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    flexShrink: 0,
                    backgroundColor:
                      isActive || isCompleted ? COLORS.themeRed : "#cccccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {isActive || isCompleted ? (
                    <CheckIcon sx={{ fontSize: 14, color: COLORS.white }} />
                  ) : (
                    <RemoveIcon sx={{ fontSize: 14, color: COLORS.white }} />
                  )}
                </Box>
                <Typography
                  sx={{
                    fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? COLORS.themeBlack : "#aaaaaa",
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  {step.label}
                </Typography>
              </Box>
              {index < STEPS.length - 1 && (
                <Box
                  sx={{
                    ml: "12px",
                    width: 2,
                    height: 24,
                    backgroundColor: "#e0e0e0",
                  }}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ApplicationSidebar;
